import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { AgreementsAutocomplete } from "@shared/components/AutocompleteFields";

export const UserListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("v1/user_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="active_agreement"
          label={translate("v1/user_admin.filters.active_agreement")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Checkbox
          name="is_admin"
          label={translate("v1/user_admin.filters.is_admin")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Checkbox
          name="is_pdv"
          label={translate("v1/user_admin.filters.is_pdv")}
        />
      </Grid>
    </Grid>
  );
});
